import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {AuthenticationService} from "../../auth/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class ShoppingHistoryService {

  private url: string = '';

  constructor(private http: HttpClient,private authenticationService: AuthenticationService) {
    this.url = environment.apiUrl;
  }

  get(): Observable<any> {
    return this.http.get(this.url+'/orders/my-orders');
  }

  
}
